import React, { FC } from "react"
import L10n from "lib/carrot-l10n"
import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { Body } from "components/views/atoms/Bodies"
import { IlloUnderwaterPlants } from "../../../atoms/Illustrations"
import { ButtonPrimary } from "../../../atoms/buttons/ButtonPrimary"
import WeWillTakeItFromHere from "../WeWillTakeItFromHere"
import { useProgressTracker } from "../../ProgressTracker"
import { Steps } from "../Workflow/Steps"
import { useBenefitEnrollmentFlow } from "../BenefitEnrollmentFlowModal"
import { useStateMachine } from "../../../../context/stateMachine/StateMachineContext"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()
const ViewName = Steps.INFO_CONNECT_INSURANCE

const ProviderNotListedInsuranceView: FC = () => {
  const { onExit } = useBenefitEnrollmentFlow()
  const { setProgress } = useProgressTracker()
  useStateMachine(ViewName, null)

  setProgress(2, "CONNECT YOUR INSURANCE")

  return (
    <div>
      <Spacer height={1.5} />
      <FlexRowCenter>
        <IlloUnderwaterPlants />
      </FlexRowCenter>
      <Spacer height={2} />
      <H2 variant="dark">{l`We’re not able to connect.`}</H2>
      <Spacer height={0.5} />

      <Body color="black-80">{l`Currently, we can only connect to insurance plans offered through your employer.`}</Body>
      <Spacer height={1} />
      <WeWillTakeItFromHere />
      <Spacer height={2} />
      <div className="flex flex-row justify-center">
        <ButtonPrimary onClick={onExit} enabled disabledBackgroundColor="black-10">
          Close
        </ButtonPrimary>
      </div>
    </div>
  )
}

export { ProviderNotListedInsuranceView }
